module.exports = require("regenerator-runtime");



//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-runtime/regenerator/index.js
// module id = Xxa5
// module chunks = 0 1 8 9 10 11 12 13 26 27 28 29 30 31 32 33 34 36 37